export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";